import { ApiError } from './api';

/**
 * Second sign-in step — SIMULATED.
 *
 * The real check belongs to Microsoft 365 (Entra ID): once SSO is connected,
 * Microsoft asks for the code and this client never sees it. Until then the
 * portal still needs to show the step, so the client plays both sides: the
 * "code" is a constant compared here, in the browser.
 *
 * It demonstrates the flow and protects nothing. Anyone who can read this file
 * can read the code, and the server has already answered the password with a
 * session by the time this runs.
 *
 * When SSO lands, either replace the two function bodies with API calls or
 * delete the step. Callers depend only on the signatures.
 */

export const OTP_LENGTH = 6;

/** The one code the simulation accepts. Shown in the dialog on purpose. */
export const OTP_DEMO_CODE = '123456';

/** Wrong codes allowed before the sign-in starts over. */
export const OTP_MAX_ATTEMPTS = 5;

/** Seconds before "Send again" becomes available. */
export const OTP_RESEND_SECONDS = 30;

const LATENCY_MS = 450;

function pause() {
  return new Promise<void>((resolve) => window.setTimeout(resolve, LATENCY_MS));
}

export async function verifyOtp(code: string): Promise<void> {
  await pause();
  if (code !== OTP_DEMO_CODE) throw new ApiError('That code is not correct.', 401);
}

export async function resendOtp(): Promise<void> {
  await pause();
}
